/* eslint-disable class-methods-use-this */
import { DefaultLinkFactory } from '@projectstorm/react-diagrams';
import CrossConnectLinkModel from './CrossConnectLinkModel';
import CrossConnectLinkWidget from './CrossConnectLinkRender';

class CrossConnectLinkFactory extends DefaultLinkFactory {
  constructor() {
    super('CrossConnect');
  }

  generateModel(): CrossConnectLinkModel {
    return new CrossConnectLinkModel();
  }

  generateReactWidget(event: any): JSX.Element {
    return <CrossConnectLinkWidget link={event.model} diagramEngine={this.engine} />;
  }
}

export default CrossConnectLinkFactory;
